module.exports = __webpack_public_path__ + "static/media/2.a4018ea2.jpg";